import { Modal } from "rizzui";
import { PiXBold } from "react-icons/pi";
import AgentInfoCard from "@/components/AgentInfoCard";
import { ICEAInfo } from "@/utilities/types/CEAInfo";
import { findPropertyAgencyByName } from "@/utilities/constants/propertyAgencies";
import { getAgentType } from "@/utilities/functions/getAgentType";

interface AgentDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  ceaInfo?: ICEAInfo;
}

export default function AgentDetailsModal({
  isOpen,
  onClose,
  ceaInfo,
}: AgentDetailsModalProps) {
  if (!ceaInfo) return null;
  const agentType = getAgentType(ceaInfo.currentEa || "");

  const ecbInfo = findPropertyAgencyByName(ceaInfo.currentEa);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" className="z-[99999]">
      <div className="relative">
        <button
          onClick={onClose}
          className="p-1 hover:bg-gray-100 rounded-full transition-colors absolute top-3 right-3"
        >
          <PiXBold className="h-5 w-5 text-gray-500" />
        </button>

        <AgentInfoCard
          title="FraudDetect • Agent"
          agentType={agentType}
          name={ceaInfo.name}
          regNo={ceaInfo.registrationNumber}
          estateAgency={ceaInfo.currentEa}
          agencySize={ecbInfo?.numberOfAgents || 1} //equal 1 to display less than 200 agents
        />
      </div>
    </Modal>
  );
}
